var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumbnail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M38.1099 51.3332H17.8877C9.97941 51.3332 4.66666 45.7866 4.66666 37.5298V18.4722C4.66666 10.2154 9.97941 4.6665 17.8877 4.6665H38.1122C46.0206 4.6665 51.3333 10.2154 51.3333 18.4722V37.5298C51.3333 45.7866 46.0206 51.3332 38.1099 51.3332Z",
    fill: "#05ADAD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.2383 20.2416C26.2383 23.4383 23.6367 26.0399 20.44 26.0399C17.241 26.0399 14.6417 23.4383 14.6417 20.2416C14.6417 17.0449 17.241 14.4409 20.44 14.4409C23.6367 14.4409 26.2383 17.0449 26.2383 20.2416ZM45.2676 32.871C45.8113 33.3983 46.2009 34.0003 46.4576 34.642C47.2346 36.5833 46.8309 38.9167 46.0003 40.8393C45.0156 43.1283 43.1303 44.8573 40.7549 45.6133C39.7003 45.9517 38.5943 46.0963 37.4906 46.0963H17.9349C15.9889 46.0963 14.2669 45.6437 12.8553 44.7943C11.9709 44.2623 11.8146 43.0373 12.4703 42.2393C13.5669 40.9093 14.6496 39.5747 15.7416 38.2283C17.8229 35.6523 19.2253 34.9057 20.7839 35.5613C21.4163 35.832 22.0509 36.2403 22.7043 36.6697C24.4449 37.8223 26.8646 39.4043 30.0519 37.687C32.2306 36.4957 33.4953 34.4571 34.5961 32.6828L34.6183 32.647C34.6923 32.5282 34.7658 32.4095 34.839 32.2912C35.2133 31.6864 35.582 31.0907 35.9996 30.5423C36.5176 29.8633 38.4403 27.74 40.9253 29.252C42.5096 30.204 43.8419 31.492 45.2676 32.871Z",
    fill: "#05ADAD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbnail);
export default __webpack_public_path__ + "static/media/thumbnail.91edab4641361e3c14761c7eed88ea11.svg";
export { ForwardRef as ReactComponent };